<template>
<div v-if="info && info.id" class="model-box venue-situation bcw">
  <div class="model-box__hd venue-situation__hd clear">
    <div class="left venue-situation__logo">
      <img v-if="info.logo" v-lazy="info.logo" :alt="info.title">
      <img v-else src="https://www.buole.com/assets/v2/img/buole_icon.jpg" :alt="info.title">
    </div>
    <h3 class="mbn ptm">{{info.title}}</h3>
    <div class="fs2 venue-situation__auth-icon auth">
      <span class="c9">营业时间：{{info.businessStartTime}}:00-{{info.businessEndTime}}:00</span>
    </div>
    <!-- <div v-if="info.isCertification" class="fs2 venue-situation__auth-icon auth"><i class="iconfont fs2 vam">&#xe630;</i>已认证 <span class="c9 mln">营业时间：{{info.businessStartTime}}:00-{{info.businessEndTime}}:00</span></div>
    <div v-else class="fs2 venue-situation__auth-icon c9"><i class="iconfont fs2 vam">&#xe630;</i>未认证 <span class="c9 mln">营业时间：{{info.businessStartTime}}:00-{{info.businessEndTime}}:00</span></div> -->
    
    <!-- <router-link :to="{name: 'venueinfo',params: {clubid: info.id}}" class="venue-situation__move fs2 c9">
      <van-icon name="arrow" class="vam" />
    </router-link> -->
  </div>
  <div class="mtm van-hairline--top"></div>
  <div class="model-box__bd venue-situation__bd ptm fs4 clear">
    <div class="left fs2 c9">{{info.address}}</div>
    <div class="right clear">
      <a :href="getMapurl">
        <van-icon class="left vam" name="location" color="#4fc852" />
      </a>
      <div class="left van-hairline--right"></div>
      <van-icon class="left vam" name="phone" @click="dial" color="#4fc852" />
    </div>
  </div>
</div>
</template>
<script>
import Vue from 'vue'
import {
  Icon,
  Lazyload
} from 'vant'
import AreaList from '@/assets/scripts/area'
Vue.use(Icon).use(Lazyload);
export default {
  name: 'TheVenue',
  props: {
    info: { // 当前俱乐部信息
      type: Object
    }
  },
  data() {
    return {
      arealist: AreaList,
    }
  },
  computed: {
    getMapurl: function() {
      // 点击导航时跳转的地图url
      // return 'https://apis.map.qq.com/uri/v1/search?keyword=' + window.encodeURIComponent(this.info.title) + '&region=' + this.arealist.city_list[this.info.city] + '&center=' + this.info.latitude + ',' + this.info.longitude +
      //   '&radius=1000&referer=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77';
      // return 'https://apis.map.qq.com/tools/poimarker?type=1&keyword='+window.encodeURIComponent(this.info.title)+'&center='+ this.info.latitude + ',' + this.info.longitude +'&radius=1000&key=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77&referer=myapp'
      
      // 位置展示
      return 'https://apis.map.qq.com/tools/poimarker?type=0&marker=coord:'+this.info.latitude + ',' + this.info.longitude +';title:'+window.encodeURIComponent(this.info.title)+';addr:'+window.encodeURIComponent(this.info.address)+'&key=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77&referer=myapp'
    }
  },
  methods: {
    dial: function() {
      // 点击电话时唤起手机拨号操作
      window.location.href = 'tel://' + this.info.contact;
    }
  }
}
</script>
<style lang="less">
// 场馆情况模块
@mg-default: 0.15rem;
.venue-situation {
    &__hd {
        position: relative;
    }
    &__bd {
        & > .right > .van-hairline--right {
            height: 0.2rem;
            margin: 0 @mg-default;
        }
        & > .left {
            margin-right: 0.7rem;
            white-space: nowrap;
            overflow: hidden;
            width: 70%;
            text-overflow: ellipsis;
        }
        & > .right {
            position: absolute;
            right: 0.15rem;
        }
    }
    &__logo {
        width: 0.7rem;
        height: 0.7rem;
        margin-right: @mg-default;
        &>img{
            width: 100%;height: 100%;object-fit: cover;
        }
    }
    &__auth-icon {
        line-height: 0.24rem;
        &.auth {
            color: #4fc852;
        }
    }
    &__move {
        position: absolute;
        top: 40%;
        right: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/TheVenue.vue